'use strict';

import $ from 'jquery';
import analytics from '../../components/Analytics/Analytics';
import CountriesAndStatesAPI from '../../components/CountriesAndStates/CountriesAndStatesAPI';

const countriesListEntryClassName = 'NewslettersForm-countryAutocompleteResults-entry';
var Backbone = require('backbone'),
  config = require('../config'),

  NewsletterTabsView = Backbone.View.extend({

    events: {
      'click .js-toggleTab': 'toggleTab'
    },

    initialize: function() {
      this.$tabButton = this.$('.js-toggleTab');
      this.$apacSubscribeButton = this.$('.NewsletterTabs-anchor');
      this.$hiddenModule = this.$el.next('.NewsletterTabs-module');
      this.$form = this.$hiddenModule.find('form');
      this.$newsLetterForm = this.$hiddenModule.find('.NewsLetterForm-submit');
      this.$newsLetterForm.click(this.submitData.bind(this));
      this.$apacSubscribeButton.click(this.submitApacData.bind(this));

      this.$countryContainer = this.$form.find('input[name*=showCountrySelector]');
      this.$languageSelector = this.$form.find('input[name*=showLanguageSelector]');
      if (this.$languageSelector.val() === 'True')
      {
        this.$languageHiddenInput = this.$form.find('#preferredLanguage1');
        this.$languageInput = this.$form.find('#newsletter-form-preferredlanguage');
        this.$languageListClickHandler = this.languageListClicked.bind(this);
        this.$languageInput.on('change', this.languageInputChanged.bind(this));
      }
      if (this.$countryContainer.val() === 'True')
      {
        this.$form.on('click', this.countriesListDisable.bind(this));
        this.$countryInput = this.$form.find('#NewslettersForm-country');
        this.$countryMobileInput = this.$form.find('#NewslettersForm-countryMobile');
        this.$countryAutocompleteResults = this.$form.find('#NewslettersForm-countryAutocompleteResults');
        this.$countryCodeInput = this.$form.find('#NewslettersForm-countryCode');
        this.$countryCodeHiddenInput = this.$form.find('#country');
        this.countries = [];
        this.initializeCountries();
        this.$countriesListClickHandler = this.countriesListClicked.bind(this);
        this.$countryInput.on('keyup', this.countryInputKeyUp.bind(this));
        this.$countryMobileInput.on('change', this.countriesMobileInputChanged.bind(this));
      }

      NewsletterTabsView.__super__.initialize.apply(this);

    },

    toggleTab: function(e) {
      e.preventDefault();

      this.$el.toggleClass('open');
      this.$tabButton.blur();
      this.$hiddenModule.toggle();
    },

    languageInputChanged: function(e) {
      let languageName = e.target.options[e.target.selectedIndex].text;
      this.$languageHiddenInput.val(languageName);
    },

    languageListClicked: function(e) {
      let languageName = e.target.textContent;
      this.$languageHiddenInput.val(languageName);
      e.stopPropagation();
    },

    pushAnalyticsEvent: function(eventType, labelData, action) {
      let analyticsFormSubmitEventSuccess = {
        event: eventType,
        category: config.analytics.categories.newsletter,
        action: action,
        label: labelData
      };
      analytics.pushToEventFramework(analyticsFormSubmitEventSuccess);
    },

    initializeCountries: function() {
      CountriesAndStatesAPI.getCmsCountriesAndStates().then(countries => {
        this.countries = countries;
        this.$countryMobileInput[0].innerHTML = '<option value=""></option>';
        countries.forEach(country => {
          this.$countryMobileInput[0].innerHTML += `<option value=${country.Iso2Code}>${country.CountryName}</option>`;
        });
        let geoCountry = this.getGeoCountry();
        if (geoCountry) {
          this.$countryMobileInput.val(geoCountry);
          this.$countryMobileInput.change();
        }
      });
    },

    getGeoCountry: function() {
      let dataLayerEntries = window.dataLayer && window.dataLayer.filter(item => item.user && item.user.profile && item.user.profile.userGeo);
      let countryCode = null;
      if (dataLayerEntries && dataLayerEntries.length) {
        countryCode = dataLayerEntries[0].user.profile.userGeo;
      }
      return countryCode;
    },

    countriesAutocompleteToShow: function(inputValue) {
      return this.countries.filter(country => {
        return (inputValue.toLowerCase() === country.CountryName.slice(0, inputValue.length).toLowerCase());
      });
    },

    countriesListDisable: function() {
      this.$countryAutocompleteResults.hide();
    },

    countryInputKeyUp: function() {
      let inputValue = this.$countryInput[0].value;
      let countriesList = this.countriesAutocompleteToShow(inputValue);
      this.$countryAutocompleteResults[0].innerHTML = '';
      this.$countryCodeInput.val('');
      this.$countryCodeHiddenInput.val('');
      $(`.${countriesListEntryClassName}`).off('click', this.$countriesListClickHandler);
      if (inputValue && countriesList.length) {
        for (let i = 0; i < countriesList.length; i++) {
          this.$countryAutocompleteResults[0].innerHTML += `<li class=${countriesListEntryClassName} data-code=${countriesList[i].Iso2Code}>${countriesList[i].CountryName}</li>`;
        }
        $(`.${countriesListEntryClassName}`).on('click', this.$countriesListClickHandler);
        this.$countryAutocompleteResults.show();
        this.removeInvalidCountryError();
      } else {
        this.$countryAutocompleteResults.hide();
      }
    },

    countriesMobileInputChanged: function(e) {
      let countryCode = e.target.value;
      let countryName = e.target.options[e.target.selectedIndex].text;
      this.$countryInput.val(countryName);
      this.$countryCodeInput.val(countryCode);
      this.$countryCodeHiddenInput.val(countryCode);
    },

    countriesListClicked: function(e) {
      let countryCode = e.target.dataset.code;
      let countryName = e.target.textContent;

      this.$countryMobileInput.val(countryCode);
      this.$countryInput.val(countryName);
      this.$countryCodeInput.val(countryCode);
      this.$countryCodeHiddenInput.val(countryCode);
      this.$countryAutocompleteResults.hide();
      e.stopPropagation();
    },

    submitApacData: function() {
      let label = 'APAC',
        eventType = config.analytics.events.click,
        action = config.analytics.actions.click;
      this.pushAnalyticsEvent(eventType, label, action);
    },

    submitData: function() {
      let label = this.$form.find('#region').val(),
        eventType = config.analytics.events.formSubmission,
        action = config.analytics.actions.FormSubmit;
      if (this.$countryCodeInput) {
        if (!this.$countryCodeInput.val()) {
          this.$countryInput.addClass(config.classes.hasCustomValidationError);
        } else {
          this.$countryInput.removeClass(config.classes.hasCustomValidationError);
        }
      }
      if (this.$form.find('input[type=checkbox]').prop('checked') && this.$form.find('input[name*=emailAddress]').is(':valid')) {
        this.pushAnalyticsEvent(eventType, label, action);
      }
    },

    removeInvalidCountryError: function removeInvalidCountryError() {
      if (this.$countryInput.hasClass(config.classes.hasCustomValidationError)) {
        this.$countryInput.removeClass(config.classes.hasCustomValidationError);
      }
    }
  }, {
    create: function($parent) {
      $parent.find('.NewsletterTabs').each(function(n, el) {
        new NewsletterTabsView({
          el: el
        });
      });
    }
  });

module.exports = NewsletterTabsView;



// WEBPACK FOOTER //
// ./assets/js/components/NewsletterTabsView.js